import React from 'react'

const Repeat = () => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 456.6 456.6'>
    <path d='M351.8 151.9c-3.4 0-6.9-1.3-9.5-3.9 -5.2-5.2-5.2-13.7 0-19l53-53 -53-53c-5.2-5.2-5.2-13.7 0-19 5.2-5.2 13.8-5.2 19 0l62.5 62.5c2.5 2.5 3.9 5.9 3.9 9.5 0 3.6-1.4 7-3.9 9.5l-62.5 62.5C358.7 150.6 355.2 151.9 351.8 151.9z' />
    <path d='M43 227.4c-7.4 0-13.4-6-13.4-13.4v-80.9c0-38.9 31.6-70.6 70.6-70.6h314.2c7.4 0 13.4 6 13.4 13.4 0 7.4-6 13.4-13.4 13.4H100.1c-24.1 0-43.7 19.6-43.7 43.7V214C56.4 221.4 50.4 227.4 43 227.4z' />
    <path d='M357.2 394H42.3c-7.4 0-13.4-6-13.4-13.4s6-13.4 13.4-13.4h314.9c24.1 0 43.7-19.6 43.7-43.7v-82.5c0-7.4 6-13.4 13.4-13.4 7.4 0 13.4 6 13.4 13.4v82.5C427.7 362.4 396.1 394 357.2 394z' />
    <path d='M104.8 456.6c-3.4 0-6.9-1.3-9.5-3.9l-62.5-62.5c-2.5-2.5-3.9-5.9-3.9-9.5s1.4-7 3.9-9.5l62.5-62.5c5.2-5.2 13.8-5.2 19 0 5.2 5.2 5.2 13.8 0 19l-53 53 53 53c5.2 5.2 5.2 13.8 0 19C111.6 455.3 108.2 456.6 104.8 456.6z' />
  </svg>
)

export default Repeat
